export default function OrderDetailsBody({ numberOfForms, language, subServices, orderStatus, orderDescription, serviceName }) {
    return (
        <>
            <h6 className="mt-3">{serviceName}</h6>
            <table className="table">
                <tbody>
                    <tr>
                        <td>عدد النماذج</td>
                        <td>{numberOfForms}</td>
                    </tr>
                    {language === "arabic" && <tr>
                        <td>اللغة</td>
                        <td>عربي</td>
                    </tr>}
                    {language === "english" && <tr>
                        <td>اللغة</td>
                        <td>إنجليزي</td>
                    </tr>}
                    {language === "arabic + english" && <tr>
                        <td>اللغة</td>
                        <td>عربي + إنجليزي</td>
                    </tr>}
                    {subServices &&
                        <tr>
                            <td>الخدمات المطلوبة</td>
                            <td>{subServices}</td>
                        </tr>
                    }
                    <tr>
                        <td>حالة الطلب</td>
                        <td>{orderStatus}</td>
                    </tr>
                </tbody>
            </table>
            <div>
                <h6 className="mt-4">تفاصيل</h6>
                <p>{orderDescription}</p>
            </div>
        </>
    )
}